import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app'

// Add the Firebase products that you want to use
import 'firebase/auth'
import 'firebase/firestore'

import axios from 'axios'
import router from '@/router'
import cookies from 'vue-cookies'

import common from '../common.js'
import constants from '../constants.js'

export default new Vuex.Store({
  state: {
    content: null,
    canLogout: true,
    clickedLogout: false,
    isLoading: false
  },
  mutations: {
    setContent(state, content) {
      state.content = content
    },
    setCanLogout(state, boolean) {
      state.canLogout = boolean
    },
    onClickLogout(state, boolean) {
      state.clickedLogout = boolean
    },
    setIsLoading(state, boolean) {
      state.isLoading = boolean
    }
  },
  actions: {
    setContent({ commit }, content) {
      commit('setContent', content)
    },
    setCanLogout({ commit }, boolean) {
      commit('setCanLogout', boolean)
    },
    onClickLogout({ commit }, boolean) {
      commit('onClickLogout', boolean)
    },
    setIsLoading({ commit }, boolean) {
      commit('setIsLoading', boolean)
    },
    promptToLogin(context) {
      const loggedIn = cookies.isKey('user_name') && cookies.isKey('token')

      if( loggedIn ){
        common.createErrorMessage('require login', 'ログインしてご利用ください。')

        cookies.remove('user_name')
        cookies.remove('user_mail')
        cookies.remove('user_photo_url')
        cookies.remove('token')
        cookies.remove('role')

        router.push({ name: 'Home' })

        context.commit('setCanLogout', true)
        context.commit('onClickLogout', false)
      }
    },
    async logout(context) {
      try {
        context.commit('setIsLoading', true)

        await firebase.auth().signOut()
        const res_logout = await axios.post(
          process.env.VUE_APP_API_ENDPOINT +
          process.env.VUE_APP_API_BASE_PATH +
          constants.API_PATH.LOGOUT
        )

        const r = res_logout.data

        if( r.status == 1 ) {
          cookies.remove('user_name')
          cookies.remove('user_mail')
          cookies.remove('user_photo_url')
          cookies.remove('token')
          cookies.remove('role')

          router.push({ name: 'Home' })

          context.commit('setCanLogout', true)
          context.commit('onClickLogout', false)
        }
      } catch (e) {
        common.createErrorMessage(e, 'ログアウトに失敗しました。時間を空けて、もう一度お試しください。')
      } finally {
        context.commit('setIsLoading', false)
      }
    },
  },
  modules: {}
})